/* eslint no-console:0 */

import PropertiesMap from 'components/PropertiesMap/PropertiesMap';
import WebpackerReact from '../webpacker_react/WebpackerReact';

WebpackerReact.setup({ PropertiesMap });
